// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Offer_offerListContainer__hglhd .Offer_ant-upload__6X8XP.Offer_ant-upload-select__0z\\+iB {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/component/pages/service-provider-admin/modules/offer-and-packages/offers/Offer.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ","sourcesContent":[".offerListContainer {\n  .ant-upload.ant-upload-select {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"offerListContainer": `Offer_offerListContainer__hglhd`,
	"ant-upload": `Offer_ant-upload__6X8XP`,
	"ant-upload-select": `Offer_ant-upload-select__0z+iB`
};
export default ___CSS_LOADER_EXPORT___;
